import React from 'react';
import { Menu, MenuChannel, MenuPosDevice } from '@/services/innovorder/menu/menu.type';
import { CopyMenuModal } from './CopyMenuModal/CopyMenuModal';
import { CreateMenuModal } from './CreateMenuModal/CreateMenuModal';
import { DeleteMenuModal } from './DeleteMenuModal/DeleteMenuModal';
import { DuplicateMenuModal } from './DuplicateMenuModal/DuplicateMenuModal';
import { PublishMenuModal } from './PublishMenuModal/PublishMenuModal';
import { MenuTableActionTypes } from '../../types';
import { AIMenuScanModal } from '../AIMenuScanModal/AIMenuScanModal';
import { ManualImportCrousModal } from '../ManualImportCrousModal/ManualImportCrousModal';

type MenuModalProps = {
    action: MenuTableActionTypes | null;
    onHide: () => void;
    brandId: number;
    restaurantId?: number;
    channels: MenuChannel[];
    posDevices: MenuPosDevice[];
    marketplaceStores: string[];
    menuId: number | null;
    isSyncFromPosEnabled: boolean;
    menuName: string | null;
    menu: Menu | null;
};

const getActionModal = (action: MenuTableActionTypes | null) => {
    switch (action) {
        case 'showCreateMenuModal':
        case 'showEditChannelModal':
            return CreateMenuModal;
        case 'showDuplicateModal':
            return DuplicateMenuModal;
        case 'showDeleteModal':
            return DeleteMenuModal;
        case 'showCopyModal':
            return CopyMenuModal;
        case 'showPublishModal':
            return PublishMenuModal;
        case 'showAIMenuScanModal':
            return AIMenuScanModal;
        case 'showToggleManualCrousImport':
            return ManualImportCrousModal;
        default:
            return null;
    }
};

export const MenuModal: React.FunctionComponent<React.PropsWithChildren<MenuModalProps>> = ({
    action,
    onHide,
    brandId,
    restaurantId,
    channels,
    posDevices,
    marketplaceStores,
    isSyncFromPosEnabled,
    menuName,
    menuId,
    menu,
}) => {
    const ActionModal = getActionModal(action);

    if (!ActionModal) {
        return ActionModal;
    }

    return (
        <ActionModal
            onHide={onHide}
            brandId={brandId}
            restaurantId={restaurantId}
            channels={channels}
            posDevices={posDevices}
            marketplaceStores={marketplaceStores}
            isSyncFromPosEnabled={isSyncFromPosEnabled}
            menuId={menuId}
            menuName={menuName}
            menu={menu}
        />
    );
};
